import { RestaurantCheckout } from '@happyspace/sdk/restaurant';
import { SITE } from '../data/site';

export default function CheckoutPage() {
  return (
    <div style={{ background: 'var(--color-surface)' }} className="min-h-screen pt-24 md:pt-28 pb-16">
      <RestaurantCheckout
        isOpen
        onClose={() => {
          window.location.href = '/menu';
        }}
        accentColor="#cf5313"
        restaurantName={SITE.name}
        taxRate={0.0825}
        onOrderSuccess={() => {
          window.location.href = '/order-confirmation';
        }}
      />
    </div>
  );
}
